// VERSION 2.2 - Implementierung Spielmodi
// =============================================================================
//  KOMPONENTE: EditEntryModal (Mit Logik für Paarbewerbe)
// =============================================================================
import React, { useState, useEffect, useMemo } from 'react';
import { CLASSIFICATIONS } from '../constants/classificationConstants';
import { GAME_MODES } from '../constants/gameModeConstants';

// NEU: Konstante zur Identifizierung von Paarbewerben
const PAIR_GAME_MODES = ['PAARBEWERB', 'TANDEM'];

// GEÄNDERT: Die Prop 'players' wird nun für die Auswahl von Spieler 2 benötigt.
const EditEntryModal = ({ entry, tournament, availableClassifications, teams, players, onClose, onSave }) => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [classification, setClassification] = useState('');
  const [gameMode, setGameMode] = useState('');
  // NEU: State für den zweiten Spieler
  const [player2Id, setPlayer2Id] = useState('');
  const [teamId, setTeamId] = useState('');
  const [guestClubName, setGuestClubName] = useState('');

  const isGuestPlayer = entry?.player && !entry.player.club;

  useEffect(() => {
    if (entry && entry.player) {
      setFirstName(entry.player.firstName);
      setLastName(entry.player.lastName);
      setClassification(entry.classification);
      setGameMode(entry.gameMode || '');
      // NEU: Den zweiten Spieler aus der Nennung laden
      setPlayer2Id(entry.player2?._id || '');
      setTeamId(entry.team?._id || '');
      setGuestClubName(entry.player.guestClubName || '');
    }
  }, [entry]);

  // NEU: Memoized Liste der verfügbaren Spieler für das zweite Dropdown
  const availablePlayersForP2 = useMemo(() => {
    if (!players || !entry?.player) return [];
    // Filtert alle Spieler heraus, die nicht der erste Spieler der Nennung sind
    return players.filter(p => p._id !== entry.player._id);
  }, [players, entry]);

  const getLabel = (key, constantList) => constantList.find(c => c.key === key)?.label || key;

  const handleSave = (e) => {
    e.preventDefault();
    const updatedData = {
      firstName,
      lastName,
      classification,
      gameMode,
      // NEU: player2 wird nur mitgesendet, wenn es ein Paarbewerb ist
      player2: PAIR_GAME_MODES.includes(gameMode) ? (player2Id || null) : null,
      team: teamId || null,
    };
    if (isGuestPlayer) {
      updatedData.guestClubName = guestClubName;
    }
    onSave(entry._id, updatedData);
  };

  if (!entry) return null;

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <h2>Nennung bearbeiten</h2>
        <form onSubmit={handleSave}>
          <div className="form-group">
            <label>Vorname (Spieler 1)</label>
            <input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Nachname (Spieler 1)</label>
            <input type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} />
          </div>
          {isGuestPlayer && (
            <div className="form-group">
              <label>Verein (Gastspieler)</label>
              <input type="text" value={guestClubName} onChange={(e) => setGuestClubName(e.target.value)} />
            </div>
          )}
          
          <div className="form-group">
            <label>Spielmodus</label>
            <select value={gameMode} onChange={(e) => setGameMode(e.target.value)}>
              {(tournament?.gameModes || []).map(gmKey => (
                <option key={gmKey} value={gmKey}>{getLabel(gmKey, GAME_MODES)}</option>
              ))}
            </select>
          </div>

          {/* NEU: Konditionales Dropdown für Spieler 2 */}
          {PAIR_GAME_MODES.includes(gameMode) && (
            <div className="form-group">
              <label>Spieler 2</label>
              <select value={player2Id} onChange={(e) => setPlayer2Id(e.target.value)}>
                <option value="">-- Keinen zweiten Spieler --</option>
                {availablePlayersForP2.map(p => (
                  <option key={p._id} value={p._id}>{p.lastName}, {p.firstName}</option>
                ))}
              </select>
            </div>
          )}
          
          <div className="form-group">
            <label>Wertung</label>
            <select value={classification} onChange={(e) => setClassification(e.target.value)}>
              {(availableClassifications || []).map(cKey => (
                <option key={cKey} value={cKey}>{getLabel(cKey, CLASSIFICATIONS)}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Mannschaft</label>
            <select value={teamId} onChange={(e) => setTeamId(e.target.value)}>
              <option value="">-- Einzelstarter --</option>
              {teams.map(team => (
                <option key={team._id} value={team._id}>{team.name}</option>
              ))}
            </select>
          </div>
          <div className="form-buttons">
            <button type="submit">Änderungen speichern</button>
            <button type="button" className="btn-cancel" onClick={onClose}>Abbrechen</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditEntryModal;